// 请求的工具函数
import serverTime from 'root/common/util/serverTime';

/**
 * @typedef {Object} Option
 * @prop {boolean} toast toast为true时，解析错误时，toast提示message
 * @prop {number} code 要对比的code
 */

const defaultOpt = {
    toast: true,
    code: 200,
};

/**
 * 接受调用api产生的promise，返回的结果使用checkCodeAndResolveData解析，返回data
 * @template T
 * @param {Promise<{data:T}>} apiPromise
 * @param {Option} [opt]
 * @returns {Promise<T>}
 * @example const data = await callWithResolve(getGoods(param))
 */
export async function resolveApi(apiPromise, opt = {}) {
    const option = { ...defaultOpt, ...opt };
    const res = await apiPromise;
    return checkCodeAndResolveData(res, option);
}

/**
 * 接受调用api产生的promise，返回的结果使用checkCodeAndResolveData解析，
 * 返回一个数组，数组
 * @template T
 * @param {Promise<{data:T}>} apiPromise
 * @param {Option} [opt]
 * @returns {Promise<[Error|null,T|null]>}
 * @example const data = await resolveApiWithError(getGoods(param))
 */
export async function resolveApiWithError(apiPromise, opt = {}) {
    const option = { ...defaultOpt, ...opt };
    const arr = [null];
    try {
        const res = await apiPromise;
        const data = checkCodeAndResolveData(res, option);
        arr[1] = data;
    } catch (error) {
        arr[0] = error;
    }
    return arr;
}

/**
 * 校验code，如果code不等于200，toast提示message
 * 如果校验通过，则返回res.data
 * @template T
 * @param {{data:T}} res
 * @param {Option} [opt]
 * @returns {T}
 */
export function checkCodeAndResolveData(res, opt = {}) {
    const option = { ...defaultOpt, ...opt };
    if (!res) throw new Error('response is null');
    if (res.code != option.code) {
        if (option.toast) window.ZZCFL.Toast(res.msg);
        const err = new Error(res.msg);
        err.res = res;
        throw err;
    }
    // 同步serverTime
    if (res.serverTime) serverTime.set(res.serverTime * 1);
    return res.data;
}

export default {
    resolveApi,
    checkCodeAndResolveData,
};
